// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OEyY7RdC7lUv_LkmW4Ej{flex-direction:column;height:100%;padding:0 20px;display:flex}.TkEkpv_8mzfnBTq1UjcN{flex-shrink:0;justify-content:space-between;margin:28px 0 17px;display:flex}.wQVBBmXeaIfgr0Py2PVu{flex-shrink:0;margin-top:-4px;margin-left:-4px}.m27yo7ULucuJI1qnoGK_{flex-direction:column;flex:1;min-height:0;margin-left:-4px;display:flex}.m27yo7ULucuJI1qnoGK_ .Yduzev_0q5YOo0hVBwRb:not(:empty){padding:30px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OEyY7RdC7lUv_LkmW4Ej`,
	"actionsContainer": `TkEkpv_8mzfnBTq1UjcN`,
	"search": `wQVBBmXeaIfgr0Py2PVu`,
	"tableContainer": `m27yo7ULucuJI1qnoGK_`,
	"footerContent": `Yduzev_0q5YOo0hVBwRb`
};
export default ___CSS_LOADER_EXPORT___;
